import { render, staticRenderFns } from "./BtnVoltar.vue?vue&type=template&id=03a23314&scoped=true&"
import script from "./BtnVoltar.vue?vue&type=script&lang=js&"
export * from "./BtnVoltar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a23314",
  null
  
)

export default component.exports